export const FETCH_WAREHOUSE_SUCCESS = 'FETCH_WAREHOUSE_SUCCESS';
export const FETCH_WAREHOUSE_REQUEST = 'FETCH_WAREHOUSE_REQUEST';
export const FETCH_WAREHOUSE_FAILURE = 'FETCH_WAREHOUSE_FAILURE';
export const fetchWarehouseSuccess = (payload) => ({
    type: FETCH_WAREHOUSE_SUCCESS,
    payload,
});
export const fetchWarehouseRequest = () => ({
    type: FETCH_WAREHOUSE_REQUEST,
});
export const fetchWarehouseFailure = (payload) => ({
    type: FETCH_WAREHOUSE_FAILURE,
    payload,
});
